import { api } from "@/lib/api";

export const reelsApi = {
    library: () => api.get("/reels/library").then((r) => r.data),
    saveProject: (body) => api.post("/reels/projects", body).then((r) => r.data),
    updateProject: (id, body) => api.put(`/reels/projects/${id}`, body).then((r) => r.data),
    getProject: (id) => api.get(`/reels/projects/${id}`).then((r) => r.data),
    deleteProject: (id) => api.delete(`/reels/projects/${id}`).then((r) => r.data),
    render: (id) => api.post(`/reels/projects/${id}/render`).then((r) => r.data),
    aiBuild: (body) => api.post("/reels/ai-build", body).then((r) => r.data),
    createFolder: (name) => api.post("/reels/folders", { name }).then((r) => r.data),
    deleteFolder: (id) => api.delete(`/reels/folders/${id}`).then((r) => r.data),
    uploadMusic: (file) => {
        const fd = new FormData();
        fd.append("file", file);
        return api.post("/reels/music/upload", fd, { headers: { "Content-Type": "multipart/form-data" } }).then((r) => r.data);
    },
};

export const fmt = (s) => {
    const t = Math.max(0, Math.floor(s || 0));
    return `${Math.floor(t / 60)}:${String(t % 60).padStart(2, "0")}`;
};
